export const brand = {
  "NAME": "SUKPK",
  "FAVICON": "maja",
  "HELP": "",
  "LOGIN": {
    "LOGO_PATH": "gmtech_applications.svg",
    "SSO": "https://sso.dis.suspk.cz/realms/suspk/protocol/openid-connect/auth",
    "SSO_LOGOUT": "https://dis.suspk.cz",
    //"SSO_LOGOUT": "https://sso.dis.suspk.cz/realms/suspk/protocol/openid-connect/logout",
    "SSO_OPTIONS": {
      "TYPE": "IDENTITY_SERVER",
      "SCOPES": ["openid", "email", "profile"],
      "CLIENT_ID": "dimap",
      "REDIRECT_URI": "https://dimap.dis.suspk.cz/"
    },
    "APP_URL": "https://gmtech.cz"
  },
  "PS": {
    "TITLE": "MAJA",
    "ICON_PATH": "maja",
    "URL_BASE_PATH": "maja"
  },
  "VISIBILITY": {
    "maja": true,
    "mpv": false,
    "common.navbar.big": false,
    "common.navbar.small": true,
    "sv.unit": true,
    "settings.modules.ps": false,
    "settings.modules.pk": false,
    "settings.modules.dimap": true,
    "settings.modules.vfze": false,
    "settings.modules.psm": true
  },
  "TRANSLATE": {
    "ps.project": "Projekt",
    "ps.projects": "Projekty",
    "ps.projectGenitive": "Projektu",
    "ps.projectAccusative": "Projekt",
    "ps.projectsAccusative": "Projektů",
    "ps.projectList": "Seznam projektů",
    "ps.projectList.total": "Celkový počet případů",
    "ps.projectList.done": "Celkový počet vypořádaných případů",
    "ps.projectList.donePercentage": "Celkový stav vypořádání v %",
    "ps.projectList.expropriationTotal": "Vyvlastnění počet případů celkem",
    "ps.projectName": "Název projektu",
    "ps.projectManager": "Manažer projektu",
    "ps.propertyActivityProcessor": "Zpracovatel MP činností",
    "ps.projectInfo": "Projekt",
    "ps.unit": "Útvar",
    "ps.investor": "Investor",
    "ps.projectSettings": "Nastavení projektu",
    "ps.infrastructure": "Infrastruktura",
    "ps.projectStartDate": "Datum spuštění projektu",
    "ps.projectState": "Stav projektu",
    "ps.projectState.CREATED": "Připravovaný",
    "ps.projectState.STARTED": "Aktivní",
    "ps.projectState.STARTED_COMPLETE": "Aktivní",
    "ps.projectState.STARTED_PARTIAL": "Aktivní",
    "ps.projectState.PAUSED": "Pozastavený",
    "ps.projectState.FINISHED": "Uzavřený",
    "ps.case.id": "Id případu",
    "login.sending": "Přihlašování...",
    "login.loggedOut": "Byli jste odhlášeni",
    "ps.easementCoefficient": "Koeficient",
    "dashboard.name": "Dashboard",
    "dashboard.header": "Projekty",
    "ps.investorCommonName": "investora",
    "sv.templatesOrganizationalUnit": "Organizační jednotka",
    "sv.section": "Úsek",
    "sv.section.invest": "Úsek výstavby",
    "sv.section.additional": "Úsek provozní"
  }
}
